import React from 'react';

import './SimpleCallout.module.css';

const SimpleCallout = ({ title, icon, copy }) => {
  return (
    <div>
      <i className={`fl-${icon}`} styleName="icon" />
      <br />
      <p styleName="callout-text">
        <strong styleName="title">{title}</strong>
        <br /> {copy}
      </p>
    </div>
  );
};

export default SimpleCallout;
